import { OrganizationInfo, UserInfo } from '../types';
import apiRequest from './apiRequest';

export type AddOrganizationMemberBody = {
  planType: 'pro' | 'unlimited';
  accessLevel?: 'EDIT' | 'VIEW';
};

export default async function putOrganizationMember(
  organizationID: string,
  userIDOrEmailAddress: string,
  body: AddOrganizationMemberBody,
) {
  return apiRequest<{ organizationInfo: OrganizationInfo; userInfo: UserInfo }>(
    'user',
    `/organizations/${organizationID}/${encodeURIComponent(userIDOrEmailAddress)}`,
    {
      method: 'PUT',
      body: JSON.stringify(body),
    },
  );
}
